import { useEffect,useState,useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Context } from '../../context/Context'
import { Alert, Button, Card, CardContent, Grid, Table, TableBody, TableCell, TableRow } from '@mui/material'
import { post } from '../../utils/axios'
import CustomButton from '../../components/Button'

import './Basket.css'

const Basket = () => {

    const context = useContext(Context)
    const navigate = useNavigate()

    const [isLoading,setIsLoading] = useState(true)
    const [hasCredit,setHasCredit] = useState(true)
    const [hasCreditLoading,setHasCreditLoading] = useState(true)
    const [basket,setBasket] = useState([])
    const [totalPrice,setTotalPrice] = useState(0)
    const [businessId,setBusinessId] = useState(0)
    const [businessTitle,setBusinessTitle] = useState('')
    const [deliverPrice,setDeliverPrice] = useState(0)
    const [guildId,setGuildId] = useState(0)

    useEffect(() => {
        let newBasket = []
        let totalPrice = 0
        let itemIndex = null
        context.basket.map(item => {
            totalPrice += item.price
            itemIndex = newBasket.findIndex(i => i.id === item.id)
            if(itemIndex != -1){
                newBasket[itemIndex].count = newBasket[itemIndex].count + 1
            }else{
                newBasket.push({...item,count: 1})
            }
        })
        if(context.basket.length){
            setBusinessId(context.basket[0].businessId)
            setGuildId(context.basket[0].guildId)
        }
        setBasket(newBasket)
        setTotalPrice(totalPrice)
        if(context.profile.roleId != 103)
            setIsLoading(false)
    },[])

    useEffect(() => {
        if(businessId && totalPrice){
            const postedData = {
                businessId,
                amount: totalPrice
            }
            const url = context.profile.roleId != 103 ? 'Payment/ValidatePay' : 'Payment/ValidatePayChild'
            post(url,postedData).then(({data}) => {
                if(data && data.data && Object.keys(data.data).length){
                    if(data.data.isSegmentBalanceForPay)
                        setHasCredit(true)
                    else
                        setHasCredit(false)
                }else
                    setHasCredit(false)
            }).finally(() => {
                setIsLoading(false)
                setHasCreditLoading(false)
            })
        }
    },[businessId,totalPrice])

    useEffect(() => {
        let newBasket = []
        let totalPrice = context.basket[0].deliverType == 2 || context.basket[0].deliverType == 3 ? deliverPrice : 0
        let itemIndex = null
        context.basket.map(item => {
            totalPrice += item.price
            itemIndex = newBasket.findIndex(i => i.id === item.id)
            if(itemIndex != -1){
                newBasket[itemIndex].count = newBasket[itemIndex].count + 1
            }else{
                newBasket.push({...item,count: 1})
            }
        })
        if(context.basket.length)
            setBusinessId(context.basket[0].businessId)
        setBasket(newBasket)
        setTotalPrice(totalPrice)
    },[context.basket,deliverPrice])

    useEffect(() => {
        if(businessId){
            const postedData = {
                id: businessId
            }
            post('Business/GetBusinessById',postedData).then(({data}) => {
                if(data.isSuccess)
                    setBusinessTitle(data.data.title)
            })
            post('Order/GetDeliverPriceOrder',{businessId}).then(({data}) => {
                if(data.isSuccess)
                    setDeliverPrice(data.data.amount)
            })
        }
    },[businessId])

    return (
        <Grid item px={0.3} sx={{position: 'relative'}}>
            <h3 className="others-page-title">سبد خرید{context.basket.length && businessTitle ? ` (${businessTitle})` : ''}</h3>
            <div className="safe-area">
                <Card sx={{width: '100%',mb: 2}}>
                    <CardContent sx={{pb: 0}}>
                        {basket.length ? <Table>
                            <TableBody>
                                {basket.map((item,index) => <TableRow key={index} sx={{'&:last-child td,&:last-child th': {border: 0,marginBottom: 0,paddingBottom: 0.5}}}>
                                    <TableCell align="right">{item.title}</TableCell>
                                    <TableCell align="right" dir="ltr"><i className="fal fa-xmark xmark-icon"></i>{item.count}</TableCell>
                                    <TableCell align="right">{new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(item.price)} ریال</TableCell>
                                </TableRow>)}
                                {context.basket[0].deliverType == 2 || context.basket[0].deliverType == 3 ? <TableRow sx={{'&:last-child td,&:last-child th': {border: 0,marginBottom: 0,paddingBottom: 0.5}}}>
                                    <TableCell align="right">هزینه ارسال</TableCell>
                                    <TableCell align="right"></TableCell>
                                    <TableCell align="right">{deliverPrice > 0 ? new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(deliverPrice) : ''} {deliverPrice > 0 ? 'ریال' : 'رایگان'}</TableCell>
                                </TableRow> : ''}
                                <TableRow sx={{'&:last-child td,&:last-child th': {border: 0,marginBottom: 0,paddingBottom: 0.5}}}>
                                    <TableCell align="right"><b>مجموع</b></TableCell>
                                    <TableCell align="right"></TableCell>
                                    <TableCell align="right">{new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(totalPrice)} ریال</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table> : <Alert severity="info" sx={{mt: 1}}>سبد خرید شما خالی می باشد</Alert>}
                        {basket.length && !hasCredit ? <Alert variant="standard" sx={{mt: 2}} color="info">موجودی شما برای این سفارش کافی نمی باشد</Alert> : ''}
                    </CardContent>
                </Card>
                {basket.length && hasCredit ? <CustomButton variant="contained" isLoading={isLoading} fullWidth onClick={() => navigate('/app/basket/confirm')} disabled={hasCreditLoading} color="success" sx={{ py: 1.5,mb: 1.5 }}>ادامه خرید و پرداخت</CustomButton> : ''}
                {basket.length ? <Button variant="contained" fullWidth onClick={() => navigate(`/app/businesses/services/${context.basket[0].businessId}`)} color="secondary" sx={{ py: 1.5 }}>{guildId == 64 ? 'بازگشت به منو' : 'لیست خدمات'}</Button> : ''}
            </div>
        </Grid>
    )
}

export default Basket